/* eslint-disable functional/prefer-readonly-type */
import React from 'react'
import { Grid } from '@mui/material'
import { State } from '@hookstate/core'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import FieldAutocompleteRegistration from '~/components/FieldAutocompleteRegistration'
import { IAnimalSpecie } from '~/features/Management/interfaces'
import ICircunstance from '~/features/Circunstance/interfaces/ICircunstance'
import IDestination from '~/features/Destination/interfaces/IDestination'

interface AnimalsFiltersProps {
  readonly animalSpecies: State<IAnimalSpecie | null>
  readonly animalCircunstance: State<ICircunstance | null>
  readonly destinationAnimalId: State<IDestination | null>
  readonly getAnimalSpecies: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getCircunstances: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getDestinations: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly translate: (key: string) => string
  readonly disableFields?: boolean
  readonly setStartDate: (date: string | null) => void
  readonly setFinishDate: (date: string | null) => void
  readonly initialPeriod: State<string>
}

export default function AnimalsFilters({
  animalSpecies,
  animalCircunstance,
  destinationAnimalId,
  getAnimalSpecies,
  getCircunstances,
  getDestinations,
  translate,
  disableFields,
  setStartDate,
  setFinishDate,
  initialPeriod,
}: AnimalsFiltersProps) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          valueId={animalSpecies.get()?.id as string}
          label={translate('Specie')}
          onValueChange={(item) => animalSpecies.set(item)}
          optionsFetch={getAnimalSpecies}
          disabled={disableFields}
        />
      </Grid>

      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          valueId={animalCircunstance.get()?.id as string}
          label={translate('Circunstance')}
          onValueChange={(item) => animalCircunstance.set(item)}
          optionsFetch={getCircunstances}
          disabled={disableFields}
        />
      </Grid>

      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          valueId={destinationAnimalId.get()?.id as string}
          label={translate('Destination')}
          onValueChange={(item) => destinationAnimalId.set(item)}
          optionsFetch={getDestinations}
          disabled={disableFields}
        />
      </Grid>
      <FilterSelectPeriod
        required
        onStartDateChange={(value) => setStartDate(value?.toJSON() ?? null)}
        onFinishDateChange={(value) => setFinishDate(value?.toJSON() ?? null)}
        onPeriodChange={(value) => initialPeriod.set(value)}
        period={initialPeriod.get()}
        sxPeriod={{ pl: 0, pt: 0 }}
        sxInitialDate={{ pl: 1, pt: 0 }}
        sxFinalDate={{ pl: 1, pt: 0 }}
      />
    </Grid>
  )
}
